module.exports = __webpack_public_path__ + "static/15.2_romes_decline_and_legacy-dcdcf73e94272dd01a8e540c2bdb61e9.pdf";